import { isValid, parseISO } from 'date-fns';
import dayjs, { Dayjs } from 'dayjs';

export function formatDate(dateInput: string | Date): string {
  if (!dateInput) {
    return '--';
  }

  let date: Date;

  if (dateInput instanceof Date) {
    date = dateInput;
  } else {
    // Try parsing different formats
    const parsedDate = new Date(dateInput);

    // Check if the parsed date is valid
    if (isNaN(parsedDate.getTime())) {
      return '--';
    }

    date = parsedDate;
  }

  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
  });
}

export const toDayjs = (date: string | Dayjs): Dayjs | null => {
  if (typeof date === 'string') {
    // Handle YYYY-MM format by converting to first day of the month
    if (date.match(/^\d{4}-\d{2}$/)) {
      const parsedDate = dayjs(`${date}-01`);
      return parsedDate.isValid() ? parsedDate : null;
    }
  }

  const parsedDate = dayjs(date);
  return parsedDate.isValid() ? parsedDate : null;
};

export const parseDateSearchParam = (dateParam?: string | null): string[] | null => {
  if (!dateParam) return null; // If undefined or null, return null

  try {
    // Decode URL-encoded characters and split by comma
    const decodedParam = decodeURIComponent(dateParam);
    const dateStrings = decodedParam.split(',');

    // Validate all dates - support both YYYY-MM-DD and YYYY-MM formats
    const validDates = dateStrings.filter(date => {
      const trimmedDate = date.trim();
      // Check for YYYY-MM-DD format
      if (trimmedDate.match(/^\d{4}-\d{2}-\d{2}$/)) {
        const parsedDate = parseISO(trimmedDate);
        return isValid(parsedDate);
      }
      // Check for YYYY-MM format (month only)
      if (trimmedDate.match(/^\d{4}-\d{2}$/)) {
        // Convert to first day of the month for validation
        const parsedDate = parseISO(`${trimmedDate}-01`);
        return isValid(parsedDate);
      }
      return false;
    });

    return validDates.length === dateStrings.length ? validDates : null;
  } catch {
    return null; // Return null in case of unexpected errors
  }
};

export const getTodayDate = () => {
  return new Date().toISOString().split('T')[0];
};

export const getCurrentYearMonths = (): string[] => {
  const now = new Date();
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  return months.slice(0, now.getMonth() + 1);
};
